import { APIBASE_HOST, MEDIABASE_HOST } from '../../common/env';

export const API_BASE_URL = `${APIBASE_HOST}/api/v1/`;
export const API_BASE_URL_STAGING = 'https://staging.plex.coach/api/v1/';
export const PL_API_BASE_URL = `${APIBASE_HOST}/plapi/v1/`;
export const MEDIA_BASE_URL = `${MEDIABASE_HOST}/assets/`;




// WEBPACK FOOTER //
// ./src/config/constants/constants.ts